import React, { useEffect } from 'react';
import { Form, Row, Col, } from 'react-bootstrap';

import DatePicker from 'react-datepicker';
import { registerLocale, setDefaultLocale } from  "react-datepicker";
import fr from 'date-fns/locale/fr';
registerLocale('fr', fr);
setDefaultLocale('fr');

const DemandeDPSLightStep2 = ({
    register,
    errors,
    setValue,
    watch,
}) => {

    useEffect(() => {
        if(!watch("manifSurVP")){setValue("manifSurVPFermee", false)};
    },[watch("manifSurVP")])

    useEffect(() => {
        if(!watch("manifCircuit")){setValue("manifCircuitCarrossable", false)};
    },[watch("manifCircuit")])

    return (<>
        <div className={"border border-1 rounded-4 p-2 position-relative mb-3 border-primary"}>
            <center><h5 className='text-primary mb-2'>Votre évènement</h5></center>
            <Row>
                <Col md="8">
                    <Form.Group className="mb-2">
                        <Form.Label>Nom de l'évènement</Form.Label>
                        <Form.Control type="text" name="libelleEvenement" id="libelleEvenement" {...register("libelleEvenement")} isInvalid={!!errors.libelleEvenement}/>
                        <small className="text-danger">{errors.libelleEvenement?.message}</small>
                    </Form.Group>
                </Col>
                <Col md="4">
                    <Form.Group className="mb-2">
                        <Form.Label>Date</Form.Label>
                        <DatePicker
                            id="dateDebutEvenement"
                            name="dateDebutEvenement"
                            selected={watch("dateDebutEvenement")}
                            onChange={(date)=>{setValue("dateDebutEvenement", date)}}
                            formatWeekDay={day => day.slice(0, 3)}
                            className='form-control'
                            placeholderText="Date de début"
                            dateFormat="dd/MM/yyyy"
                            fixedHeight
                            locale="fr"
                            minDate={new Date()}
                        />
                        <small className="text-danger">{errors.dateDebutEvenement?.message}</small>
                    </Form.Group>
                </Col>
            </Row>
        </div>

        <div className={"border border-1 rounded-4 p-2 position-relative mb-3 border-primary"}>
            <center><h5 className='text-primary mb-2'>Descriptif rapide</h5></center>
            <Form.Group className="mb-2">
                <Form.Control as="textarea" rows={10} name="manifRemarques" id="manifRemarques" {...register("manifRemarques")} isInvalid={!!errors.manifRemarques}/>
                <small className="text-danger">{errors.manifRemarques?.message}</small>
            </Form.Group>
        </div>

    </>);
};


DemandeDPSLightStep2.propTypes = {};

export default DemandeDPSLightStep2;